import { FC, ReactNode } from 'react'
import { Card } from '@lifedot/atoms/Card'
import {
  PanelHeader,
  PanelHeaderProps,
  PanelContent,
  PanelContentProps,
  PanelFooter,
  PanelFooterProps,
  Selects
} from './parts'

export interface SelectPanelWrapperProps {
  children: ReactNode
  headerTools?: PanelHeaderProps['tools']
  title: PanelHeaderProps['title']
  caption?: PanelContentProps['caption']
  handleSubmit: PanelFooterProps['onClick']
  submitButtonText: PanelFooterProps['buttonText']
  submitButtonLeftText?: PanelFooterProps['buttonLeftText']
  selects: Selects
  submitDisabled?: boolean
}

export const SelectPanelWrapper: FC<SelectPanelWrapperProps> = (props) => {
  const {
    title,
    headerTools,
    caption,
    submitButtonText,
    submitButtonLeftText,
    handleSubmit,
    selects,
    submitDisabled,
    children
  } = props

  return (
    <Card round={1}>
      <PanelHeader title={title} tools={headerTools} />
      <PanelContent caption={caption}>{children}</PanelContent>
      <PanelFooter
        buttonLeftText={submitButtonLeftText}
        buttonText={submitButtonText}
        onClick={handleSubmit}
        selects={selects}
        disabled={submitDisabled}
      />
    </Card>
  )
}
